export { copyHtmlToClipboard } from "utils/opportunityNoteContent";

/** @param {string} content */
export const normalizeCustomerNoteForSave = (content) => {
  const trimmed = String(content || "").trim();
  if (!trimmed) {
    return "";
  }
  const textOnly = trimmed.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, " ").trim();
  if (!textOnly && !/<(table|img|hr|br)\b/i.test(trimmed)) {
    return "";
  }
  return trimmed;
};

/** @param {{ note?: string }|null|undefined} note */
export const isHtmlCustomerNote = (note) => {
  const content = String(note?.note || "").trim();
  if (!content) {
    return false;
  }
  return /<[a-z][\s\S]*>/i.test(content);
};
